import { SvgIconProps, SvgIcon } from '@mui/material'
import { FC } from 'react'

export const SpinnerIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="201"
      height="201"
      viewBox="0 0 201 201"

      xmlns="http://www.w3.org/2000/svg"
      fill="#00598E"
      {...props}
    >
      <path

        d="M201 100.5C201 78.3199 193.663 56.7628 180.131 39.1884C166.6 21.6139 147.635 9.00947 126.192 3.33937C104.749 -2.33072 82.032 -0.74792 61.5824 7.84111C41.1328 16.4301 24.0989 31.5429 13.1356 50.824C2.17218 70.1051 -2.10483 92.4715 0.971098 114.437C4.04702 136.403 14.3031 156.734 30.1409 172.262C45.9787 187.791 66.5085 197.643 88.5307 200.285C110.553 202.926 132.831 198.208 151.891 186.867L150.071 183.808C131.686 194.748 110.197 199.299 88.9546 196.751C67.7122 194.203 47.9095 184.699 32.6325 169.721C17.3556 154.743 7.46274 135.132 4.49574 113.944C1.52875 92.7558 5.6543 71.1815 16.2294 52.5832C26.8046 33.9849 43.2352 19.4073 62.9606 11.1225C82.686 2.8376 104.598 1.31085 125.282 6.78015C145.966 12.2494 164.259 24.4075 177.311 41.3596C190.363 58.3117 197.441 79.1053 197.441 100.5H201Z"

      />
    </SvgIcon>
  )
}
